import { render, staticRenderFns } from "./AppointmentSettingsForm.vue?vue&type=template&id=250ea6b6&scoped=true&"
import script from "./AppointmentSettingsForm.vue?vue&type=script&lang=ts&"
export * from "./AppointmentSettingsForm.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentSettingsForm.vue?vue&type=style&index=0&id=250ea6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250ea6b6",
  null
  
)

export default component.exports